import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  public reportsData = new BehaviorSubject<any>(null);
  reportsData$ = this.reportsData.asObservable();
  public reportsDetails = new BehaviorSubject<any>(null);
  reportsDetails$ = this.reportsDetails.asObservable();

  constructor(public baseService: BaseService,) { }

  public getReports() {
    this.baseService
      .get(`${config.REPORTS}`)
      .subscribe((res) => {
        this.reportsData.next(res);
      });
  }
  getreportDetails(param,userName){
    return this.baseService.get(`${config.REPORTDETAILS}`+ param,{customerId:userName})
  }
}
